import React from 'react';
import { CollapsiblePanel, EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, PanelBody, Tray } from '../../components/elements';
import { ISurveyTemplateUnitData } from '../../components/Surveys/ISurveyTemplateUnitData';
import { getOpenApiRouteItemUrlValidatingElements } from '../../components/validatingComponents/getOpenApiRouteItemUrlValidatingElements';
import { ValidatingEditPanelSaveButton } from '../../components/validatingElements';
import { useTranslate } from '../../mixins/translate/translate';
import { nen3140SelectOptions } from './nen3140SelectOptions';

const validatingElements = getOpenApiRouteItemUrlValidatingElements('/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/nen3140', 'post');

export function SurveyEditNen3140UnitResult(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateUnitData,
) {
    const translate = useTranslate();

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <CollapsiblePanel heading={{ dark: true, text: `${translate('nen3140.nen3140')} - ${props.unitName}` }}>
                    <PanelBody isForm={true}>
                        <validatingElements.ItemUrlForm
                            onSubmitted={props.onItemChanged}
                            routeParams={{
                                surveyId: props.surveyId,
                                unitId: props.unitId,
                            }}
                        >
                            <EditPanelRow>
                                <EditPanelCell rowCount={12}>
                                    {' '}
                                    <validatingElements.FilterDropdown
                                        name="nen3140Score"
                                        selectOptions={nen3140SelectOptions.nen3140Score}
                                        topLabel="Beoordeling"
                                    />{' '}
                                </EditPanelCell>
                            </EditPanelRow>
                            <EditPanelRow>
                                <EditPanelCell rowCount={12}>
                                    <validatingElements.TextArea name="remarks" topLabel={translate('common.remarks')} />
                                </EditPanelCell>
                            </EditPanelRow>
                            <EditPanelButtons>
                                <ValidatingEditPanelSaveButton small={true} />
                            </EditPanelButtons>
                        </validatingElements.ItemUrlForm>
                    </PanelBody>
                </CollapsiblePanel>
            </EditPanel>
        </Tray>
    );
}
